// Produce a cropped image Blob from a source URL + pixel crop area (react-easy-crop).
export default function getCroppedImg(imageSrc, pixelCrop, mimeType = "image/jpeg") {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.crossOrigin = "anonymous";
    image.onload = () => {
      const canvas = document.createElement("canvas");
      const w = Math.max(1, Math.round(pixelCrop.width));
      const h = Math.max(1, Math.round(pixelCrop.height));
      canvas.width = w;
      canvas.height = h;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(
        image,
        Math.round(pixelCrop.x),
        Math.round(pixelCrop.y),
        w,
        h,
        0,
        0,
        w,
        h,
      );
      const out = mimeType === "image/png" ? "image/png" : "image/jpeg";
      canvas.toBlob(
        (blob) => (blob ? resolve(blob) : reject(new Error("Canvas is empty"))),
        out,
        0.92,
      );
    };
    image.onerror = () => reject(new Error("Failed to load image"));
    image.src = imageSrc;
  });
}
